module.exports = __webpack_public_path__ + "static/media/miterDefault.48730a5d.png";